import { SVGChevronDown } from "@/lib/svg";
import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
`;

export const Title = styled.div`
  padding: 2.5rem 0;
  font-family: ${({ theme }) => theme.fontFamilies.secondary};
  font-weight: 400;
  line-height: 1.2;
  font-size: 1.25rem;
  display: flex;
  align-items: center;
  gap: 0.4em;
`;

export const Icon = styled(SVGChevronDown)<{ $menuIsOpen?: boolean }>`
  width: 1rem;
  transform: ${({ $menuIsOpen }) => ($menuIsOpen ? "rotate(180deg)" : "none")};
`;

export const Pin = styled.span`
  width: 0.5rem;
  height: 0.5rem;
  background-color: ${({ theme }) => theme.colors.red};
  border-radius: 50%;
`;
